module.exports = __webpack_public_path__ + "static/img/protect_3.83471308.png";